import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import image from '../../assest/commingsoonremovebg.png'

const UnderDevelopmentPage = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "80vh",
            }}
        >
            <Box
                component="img"
                src={image}
                alt="Under Development"
                sx={{
                    width: 400,
                    height: 400,
                    mb: 2,
                }}
            />
            <Typography variant="h6" sx={{textAlign: 'center'}}>
                <span style={{ color: '#164CA3', fontFamily: 'monospace', fontWeight: 'bold', fontSize: '26px' }}>Under Development....</span><br /> <span style={{ color: '#164CA3', fontSize: '16px' }}>We are working on it to bring you an amazing experience.
                    Stay tuned — exciting updates are on the way!</span>
            </Typography>
        </Box>
    )
}

export default UnderDevelopmentPage
